/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType } from "./http-client";
export class Contracts {
  http;
  constructor(http) {
    this.http = http;
  }
  /**
   * No description
   *
   * @tags Contracts
   * @name GetRentGuaranteeQuote
   * @summary Get Rent Guarantee Quote
   * @request POST:/api/contracts/{contract_id}/insurance/quote
   * @secure
   */
  getRentGuaranteeQuote = (contractId, params = {}) =>
    this.http.request({
      path: `/api/contracts/${contractId}/insurance/quote`,
      method: "POST",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Contracts
   * @name AcceptRentGuaranteeQuote
   * @summary Accept Rent Guarantee Quote
   * @request POST:/api/contracts/{contract_id}/insurance/accept
   * @secure
   */
  acceptRentGuaranteeQuote = (contractId, data, params = {}) =>
    this.http.request({
      path: `/api/contracts/${contractId}/insurance/accept`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
